import { useEffect, useState } from "react";
import { getPartnerName, isDev } from "../helpers";

export function useDistance(address) {
  const [res, setRes] = useState();
  const [requestStatus, setRequestStatus] = useState();
  useEffect(() => {
    console.log(address);
    if (address.customerAddress) {
      const service = new window.google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        {
          origins: [address.partnerAddress],
          destinations: [address.customerAddress],
          travelMode: "DRIVING",
        },
        (response, status) => {
          if (isDev) console.log("google maps distance matrix");
          setRes(response);
          setRequestStatus(status);
        }
      );
    }
  }, [address]);

  if (requestStatus) {
    const queryStatus = res.rows[0].elements[0].status;
    return {
      customerAddress: res.destinationAddresses[0],
      distance:
        queryStatus === "OK" ? res.rows[0].elements[0].distance.value : null,
      status: queryStatus,
      requestStatus,
    };
  }
  return {
    customerAddress: null,
    distance: null,
    status: null,
    requestStatus: null,
  };
}
